import _extends from '@babel/runtime/helpers/extends';
import React from 'react';
import PropTypes from 'prop-types';
import { c as classNamePropTypes } from './classNames-cc2dcbf1.js';
import { m as marginPropTypes } from './spacing-7e57ffb0.js';
import { S as SvgIcon } from './SvgIcon-1308e965.js';

function IconFire(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M17.624 15.814a5.612 5.612 0 0 1-1.325 2.268 5.338 5.338 0 0 1-2.186 1.375 1.212 1.212 0 0 1-1.18-.25 1.3 1.3 0 0 1-.418-.782 1.326 1.326 0 0 1 .174-.875c.156-.26.398-.454.68-.547a2.876 2.876 0 0 0 1.178-.74 3.01 3.01 0 0 0 .714-1.222 1.3 1.3 0 0 1 .232-.44c.105-.13.233-.237.377-.315a1.199 1.199 0 0 1 1.37.155c.124.108.227.24.302.39a1.322 1.322 0 0 1 .084.981l-.002.002ZM22 14.143c0 2.614-1 5.121-2.782 6.97C17.436 22.962 15.02 24 12.5 24c-2.52 0-4.936-1.038-6.718-2.887C4.001 19.264 3 16.757 3 14.143c0-3.087 1.164-6.234 3.457-9.352.106-.144.24-.264.395-.35a1.206 1.206 0 0 1 1.454.208l2.033 2.047 2.058-5.85a1.29 1.29 0 0 1 .326-.508c.146-.139.323-.24.514-.293a1.195 1.195 0 0 1 1.115.252C16.652 2.277 22 7.59 22 14.143Zm-2.478 0c0-4.47-3.161-8.4-5.423-10.639L12.011 9.44c-.071.202-.19.382-.345.524a1.224 1.224 0 0 1-.543.289 1.195 1.195 0 0 1-.61-.015 1.23 1.23 0 0 1-.53-.316L7.618 7.538c-1.418 2.253-2.14 4.468-2.14 6.605 0 1.932.74 3.785 2.057 5.152a6.895 6.895 0 0 0 4.965 2.134 6.895 6.895 0 0 0 4.965-2.134 7.427 7.427 0 0 0 2.057-5.152Z"
  }));
}
IconFire.propTypes = {
  /** size of icon */
  size: PropTypes.oneOf(['sm', 'smd', 'md', 'mlg', 'lg', 'none']),
  /** CSS class to use, if any */
  className: classNamePropTypes,
  /** color, if not inheriting from parent's text color */
  color: PropTypes.oneOf(['ink', 'blurple', 'asphalt', 'lava', 'emerald', 'white']),
  /** margin for icon, if any */
  margin: marginPropTypes
};
IconFire.defaultProps = {
  size: 'md',
  className: '',
  margin: null,
  color: null
};

export { IconFire as default };
